import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvTaskDescriptGroupEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../../_loadingHelpers/MainCatalogTypes";

class EvTaskDescriptGroupEditorV2 extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.EvTaskDescriptGroup;
    }

    protected beforeDelete() {
        let evTasks = this.getAttributeValue("EL_vt_task_description_task_grp");
        if (evTasks && evTasks.length > 0) {
            this.showToast(this.translate("EvTaskDescriptGroup_Error_NoDelete"), "fas fa-exclamation-triangle");
            return;
        }
        super.beforeDelete.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvTaskDescriptGroupEditorV2);